import * as actions from './filter/actions'
import * as getters from './filter/getters'
import mutations from './filter/mutations'

const state = () => {
	return {
		showFilter: false,
		filter: null
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
